import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue-demi';
import { useCdnImg } from '@webplatform/cdn-image';
import AbRichVideo from '../AbRichVideo/AbRichVideo.vue';

interface Props {
  video:
    | string
    | {
        src?: string;
        id?: string;
      };
  play?: boolean;
  videoClass?: string;
  containerSize?: boolean;
  autoplay?: boolean;
  muted?: boolean;
  loop?: boolean;
  controls?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbVideo',
  props: {
    video: null,
    play: { type: Boolean, default: false },
    videoClass: null,
    containerSize: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: false },
    muted: { type: Boolean, default: true },
    loop: { type: Boolean, default: true },
    controls: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { video:
    | string
    | {
        src?: string;
        id?: string;
      }, play: boolean, videoClass?: string, containerSize: boolean, autoplay: boolean, muted: boolean, loop: boolean, controls: boolean };



const videoRef = ref();
const { generateUrl } = useCdnImg();

const getYoutubeId = (value = '') => {
  if (value) {
    if (/^[A-Za-z0-9_-]{11}$/.test(value)) return value;

    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;

    const match = value.match(regExp);
    if (match && match[2]) return match[2];
  }
  return null;
};

const videoSrcRaw = computed(() => {
  if (typeof props.video === 'string') return props.video;
  if (props.video?.src) return props.video.src;
  return null;
});

const videoSrc = computed(() =>
  typeof props.video !== 'string' && !props.video?.id && videoSrcRaw.value
    ? generateUrl(videoSrcRaw.value, {})
    : null
);

const videoId = computed(() => {
  if (typeof props.video !== 'string' && props.video?.id) return props.video.id;
  return videoSrcRaw.value ? getYoutubeId(videoSrcRaw.value) : null;
});

const start = () => videoRef.value?.play();
const stop = () => videoRef.value?.pause();

watch(
  () => props.play,
  (doPLay) => {
    doPLay ? start() : stop();
  }
);

return { __sfc: true,props, videoRef, generateUrl, getYoutubeId, videoSrcRaw, videoSrc, videoId, start, stop, AbRichVideo }
}

})